module.exports = __webpack_public_path__ + "img/scene-anchor.6dffae1c.svg";